import eMulti from '../pages/IndicadoresAps/eMulti/Index.vue'

export default [
  {
    path: '/emulti',
    component: eMulti,
  },
  {
    path: '/media-atendimentos-por-pessoa',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eMulti/MediaAtendimentosPorPessoa/components/Template.vue'
      ),
    children: [
      {
        path: '/media-atendimentos-por-pessoa',
        component: () =>
          import(
            '@/pages/IndicadoresAps/eMulti/MediaAtendimentosPorPessoa/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/acoes-interprofissionais',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eMulti/AcoesInterprofissionais/components/Template.vue'
      ),
    children: [
      {
        path: '/acoes-interprofissionais',
        component: () =>
          import(
            '@/pages/IndicadoresAps/eMulti/AcoesInterprofissionais/Index.vue'
          ),
      },
    ],
  },
]
